import React, { FC, memo, useState } from 'react';

import { TabPanel } from 'devextreme-react';

import { ComingFare, ComingNomenclatureAdjustment } from './components';

const itemTitleRender = (tab: { name: string; index: number }) => {
  return <span>{tab.name}</span>;
};

const ItemsTabs = memo((props: { index: number; data: any }) => {
  switch (props.index) {
    case 0:
      return (
        <div className="tab-content">
          <ComingFare />
        </div>
      );
    case 1:
      return (
        <div className="tab-content">
          <ComingNomenclatureAdjustment />
        </div>
      );
    default:
      return <div></div>;
  }
});

const tabs = [
  {
    name: 'Расчет запчастей',
    index: 0,
  },
  {
    name: 'Корректировки',
    index: 1,
  },
];

const ComingFareWrap: FC = () => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  return (
    <div>
      <TabPanel
        height="auto"
        dataSource={tabs}
        selectedIndex={selectedIndex}
        onOptionChanged={(e) => {
          if (e.name === 'selectedIndex') {
            setSelectedIndex(e.value);
          }
        }}
        itemTitleRender={itemTitleRender}
        animationEnabled={false}
        itemComponent={ItemsTabs}
      />
    </div>
  );
};

export default ComingFareWrap;
